import axios from 'axios-https-proxy-fix'
import eventBus from '@/js/utils/eventBus'
// import config from '@/js/utils/config'
// let Base64 = require('js-base64').Base64
/*global  process:true*/
axios.interceptors.response.use(

  response => {

    return response
  },

  error => {

    if (error.response) {
      if (error.response.status == 401) {
        eventBus.$emit('logout')
      }else {
        if (error.response.status >= 400 && error.response.status<500) {
            //弹框提示错误信息
          eventBus.$emit('showerrorinfo', error)
        }
      }
    }
    return Promise.reject(error.response.data) // 返回接口返回的错误信息
  })

let HttpUtils = {
  credentials: true,
  host: process.env.HOST_NAME,
  get(url, params) {
    const proxy = {
      host: this.host,
      port: 443
    }
    return axios({
      method: 'get',
      url: url,
      params: params,
      proxy: proxy,
      withCredentials: this.credentials
    })
  },

  post(url, body) {
    const proxy = {
      host: this.host,
      port: 443
    }
    return axios({
      method: 'post',
      url: url,
      data: body,
      proxy: proxy,
      withCredentials: this.credentials
    })
  },
  postParams(url, params, body) {
    const proxy = {
      host: this.host,
      port: 443
    }
    return axios({
      method: 'post',
      url: url,
      params: params,
      data: body,
      proxy: proxy,
      withCredentials: this.credentials
    })
  },
  put(url, body) {
    const proxy = {
      host: this.host,
      port: 443
    }
    return axios({
      method: 'put',
      url: url,
      data: body,
      proxy: proxy,
      withCredentials: this.credentials
    })
  },
  patch(url, params) {
    const proxy = {
      host: this.host,
      port: 443
    }
    return axios({
      method: 'patch',
      url: url,
      data: params,
      proxy: proxy,
      withCredentials: this.credentials
    })
  },
  delete(url, params) {
    const proxy = {
      host: this.host,
      port: 443
    }
    return axios({
      method: 'delete',
      url: url,
      params: params,
      proxy: proxy,
      withCredentials: this.credentials
    })
  },
}

export default HttpUtils



// WEBPACK FOOTER //
// ./src/js/utils/http.utils.js